// Stripe product configuration
export const PRODUCTS = {
  PRO: {
    MONTHLY: {
      name: 'Pro Monthly',
      description: 'Pro plan billed monthly',
      priceId: 'price_1RDsdhSGEzinK1I1kzuUz9Ek',
      mode: 'subscription',
      price: '$7.00/month',
      features: [
        'All free features',
        'Unlimited projects',
        'Unlimited tasks',
        'Advanced AI features',
        'Priority support'
      ]
    },
    YEARLY: {
      name: 'Pro Yearly',
      description: 'Pro plan billed yearly (save 17%)',
      priceId: 'price_1RDse3SGEzinK1I1wXp8yPIh',
      mode: 'subscription',
      price: '$75.00/year',
      features: [
        'All free features',
        'Unlimited projects',
        'Unlimited tasks',
        'Advanced AI features',
        'Priority support'
      ]
    }
  },
  BUSINESS: {
    MONTHLY: {
      name: 'Business Monthly',
      description: 'Business plan billed monthly',
      priceId: 'price_1RDskzSGEzinK1I1JDHed7cD',
      mode: 'subscription',
      price: '$10.00/month',
      features: [
        'All Pro features',
        'Team collaboration',
        'Advanced analytics',
        'Custom integrations',
        'Dedicated account manager'
      ]
    },
    YEARLY: {
      name: 'Business Yearly',
      description: 'Business plan billed yearly (save 17%)',
      priceId: 'price_1RDsljSGEzinK1I1DsJEpRbf',
      mode: 'subscription',
      price: '$99.00/year',
      features: [
        'All Pro features',
        'Team collaboration',
        'Advanced analytics',
        'Custom integrations',
        'Dedicated account manager'
      ]
    }
  }
};

// Helper function to get product by price ID
export function getProductByPriceId(priceId: string) {
  for (const productCategory in PRODUCTS) {
    for (const interval in PRODUCTS[productCategory as keyof typeof PRODUCTS]) {
      const product = PRODUCTS[productCategory as keyof typeof PRODUCTS][interval as 'MONTHLY' | 'YEARLY'];
      if (product.priceId === priceId) {
        return {
          ...product,
          category: productCategory,
          interval
        };
      }
    }
  }
  return null;
}

// Helper function to get subscription plan name from price ID
export function getPlanNameFromPriceId(priceId: string): string {
  const product = getProductByPriceId(priceId);
  if (!product) return 'Free';
  return product.name;
}